module.exports = __webpack_public_path__ + "img/extend-icon.66590252.png";